import { WithList } from '@bv/api/crud';

/**
 * Manages AI agent's voices.
 * It provides full CRUD (Create, Read, Update, Delete) functionality
 */
class AiAgentVoiceApi extends WithList<AiAgentVoice> {
  public constructor(public endpoint = 'ai-agent/voices') {
    super(endpoint);
  }
}

export const aiAgentVoiceApi = new AiAgentVoiceApi();
